import CatalogFilter from "../../components/Catalog/CatalogFilter";
import { ECatalogFilter } from "../../components/Catalog/ECatalogFilter";
import BaseCCatalogListFilters from "../../components/Catalog/BaseCCatalogListFilters";
import BaseCCatalogList from "../../components/Catalog/BaseCCatalogList";
import MCatalogTemplate from "./MCatalogTemplate";

export default class CCatalogListFilters extends BaseCCatalogListFilters {
  private languageFilter: CatalogFilter;
  private difficultyFilter: CatalogFilter;
  private gradeFilter: CatalogFilter;
  private subjectFilter: CatalogFilter;
  private typeFilter: CatalogFilter;
  private regionFilter: CatalogFilter;

  constructor(listController: BaseCCatalogList) {
    super(listController);

    this.languageFilter = new CatalogFilter(this, ECatalogFilter.LANGUAGE);
    this.difficultyFilter = new CatalogFilter(this, ECatalogFilter.DIFFICULTY);
    this.gradeFilter = new CatalogFilter(this, ECatalogFilter.GRADE);
    this.subjectFilter = new CatalogFilter(this, ECatalogFilter.SUBJECT);
    this.typeFilter = new CatalogFilter(this, ECatalogFilter.TYPE);
    this.regionFilter = new CatalogFilter(this, ECatalogFilter.REGION);
    this.init();
  }

  public ApplyFilters(): void {
    this.listController.filteredTemplates = this.FilterBy();
    this.languageFilter.UpdateCounter();
    this.difficultyFilter.UpdateCounter();
    this.gradeFilter.UpdateCounter();
    this.subjectFilter.UpdateCounter();
    this.typeFilter.UpdateCounter();
    this.regionFilter.UpdateCounter();
  }

  /**
   * Filter the template list by the current options filter values
   * @param filter  The return value will the filtered list element without this specific one
   *                Useful to determine the counter of this filter
   * @constructor
   */
  public FilterBy(filter?: ECatalogFilter): MCatalogTemplate[] {
    const filteredList: MCatalogTemplate[] = [];
    this.listController.templates.forEach((template: MCatalogTemplate) => {
      if (
        filter !== ECatalogFilter.LANGUAGE &&
        !template.HasFilter(
          this.languageFilter.currentFilter,
          ECatalogFilter.LANGUAGE,
        )
      ) {
        return;
      }
      if (
        filter !== ECatalogFilter.DIFFICULTY &&
        !template.HasFilter(
          this.difficultyFilter.currentFilter,
          ECatalogFilter.DIFFICULTY,
        )
      ) {
        return;
      }
      if (
        filter !== ECatalogFilter.GRADE &&
        !template.HasFilter(
          this.gradeFilter.currentFilter,
          ECatalogFilter.GRADE,
        )
      ) {
        return;
      }
      if (
        filter !== ECatalogFilter.SUBJECT &&
        !template.HasFilter(
          this.subjectFilter.currentFilter,
          ECatalogFilter.SUBJECT,
        )
      ) {
        return;
      }

      if (
        filter !== ECatalogFilter.TYPE &&
        !template.HasFilter(this.typeFilter.currentFilter, ECatalogFilter.TYPE)
      ) {
        return;
      }
      if (
        filter !== ECatalogFilter.REGION &&
        !template.HasFilter(
          this.regionFilter.currentFilter,
          ECatalogFilter.REGION,
        )
      ) {
        return;
      }
      filteredList.push(template);
    });
    return filteredList;
  }

  protected resetFilters(): void {
    this.setDefaultLanguage();
    this.difficultyFilter.SelectOption(null);
    this.gradeFilter.SelectOption(null);
    this.subjectFilter.SelectOption(null);
    this.typeFilter.SelectOption(null);
    this.regionFilter.SelectOption(null);
  }

  protected setDefaultLanguage(): void {
    const defaultLanguageId = $(".challenge-template-container").data(
      "default-language",
    ) as number | undefined;
    this.languageFilter.optionsContainers.removeClass("filter-active");

    if (defaultLanguageId !== undefined) {
      this.languageFilter.SelectOption(
        this.languageFilter.GetOptionByFilter(defaultLanguageId),
      );
    } else {
      this.languageFilter.SelectOption(null);
    }
  }

  protected applyUrlFilters(): void {
    this.languageFilter.ApplyUrlFilter();
    this.gradeFilter.ApplyUrlFilter();
    this.subjectFilter.ApplyUrlFilter();
    this.typeFilter.ApplyUrlFilter();
  }
}
